import { memo } from 'react';

import { WorkspaceAgentBoardListPill } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentBoardListPill';
import { WorkspaceAgentPendingPill } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentPendingPill';
import { WorkspaceAgentUnavailablePill } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentUnavailablePill';
import { usePrivateWorkspaceAgentHydratedArtifactPill } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/usePrivateWorkspaceAgentHydratedArtifactPill';
import { type BoardListPill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';

export type PrivateWorkspaceAgentBoardListPillChipProps = {
  isStreaming: boolean;
  pill: BoardListPill;
};

export const PrivateWorkspaceAgentBoardListPillChip = memo(
  ({ isStreaming, pill }: PrivateWorkspaceAgentBoardListPillChipProps) => {
    const {
      inViewRef,
      isPending,
      isUnavailable,
      pill: hydrated,
    } = usePrivateWorkspaceAgentHydratedArtifactPill({
      isStreaming,
      pill,
    });
    const listPill = hydrated.type === 'boardList' ? hydrated : pill;

    if (isPending) {
      return (
        <span className="inline-flex max-w-full items-center align-middle leading-none" ref={inViewRef}>
          <WorkspaceAgentPendingPill label="Boards" />
        </span>
      );
    }

    if (isUnavailable || hydrated.type !== 'boardList') {
      return (
        <span className="inline-flex max-w-full items-center align-middle leading-none" ref={inViewRef}>
          <WorkspaceAgentUnavailablePill kind="reference" referenceId={pill.id} />
        </span>
      );
    }

    return <WorkspaceAgentBoardListPill boardCount={listPill.count} />;
  },
);

PrivateWorkspaceAgentBoardListPillChip.displayName = 'PrivateWorkspaceAgentBoardListPillChip';
